export const COLOR_OPTONS_ELEMENT = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.ColorOptionsElement';
